/** @format */

const template = `
<div class="messages">
  <div class="row">
    <div class="col-12">
      <h1 class="page-title fake-crumbs" tabindex="-1" ng-if="$ctrl.showMessagesHeading" translate="MESSAGES.PAGE_TITLE"></h1>
      <div
        ng-if="$ctrl.showMessageFilters"
        class="search-and-results"
        search-and-results
        search-params="$ctrl.searchParams"
        search-service="$ctrl.searchService">
        <ng-form name="filterMessages" search-parameters>
          <div class="row">
            <div class="col-md-12 col-md-8 col-lg-7 col-xl-6">
              <ng-form name="searchForm" ng-model-options="::{ debounce: 700 }">
                <div class="search-group">
                  <input
                    type="text"
                    search-bar
                    class="form-control"
                    placeholder="{{:: 'MESSAGES.SEARCH_HINT' | translate}}"
                    ng-model="searchParamsCtrl.params.searchString.value" />
                  <sis-icon icon="search" class="search-with-svg-icon"></sis-icon>
                  <search-filter-options-menu
                    class="input-group-btn"
                    on-select="searchParamsCtrl.selectAllParametersFromValues(parameterKey, values)"
                    search-parameter-options="$ctrl.searchParameterOptions"
                    search-params="$ctrl.searchParams"
                    search-again="searchParamsCtrl.searchAgain()">
                  </search-filter-options-menu>
                </div>
              </ng-form>

              <div class="row">
                <div class="col-sm-12 search-filters">
                  <display-selected-parameters
                    selectable-parameters="$ctrl.searchParameterOptions"
                    on-parameter-change="searchParamsCtrl.selectAllParametersFromValues(parameterKey, values)"
                    search-params="$ctrl.searchParams"
                    search-again="searchParamsCtrl.searchAgain()">
                  </display-selected-parameters>
                </div>
              </div>
            </div>
          </div>
          <div class="row search-result-info" ng-if="$ctrl.hasValidSearchParameters()">
            <div class="col-sm-12">
              <span class="guidance" ng-if="$ctrl.totalItems === 0" translate="SEARCH_RESULTS.ZERO_RESULTS"></span>
              <span class="guidance" ng-if="$ctrl.totalItems === 1" translate="SEARCH_RESULTS.ONE_RESULT"></span>
              <span
                class="guidance"
                ng-if="$ctrl.totalItems > 1"
                translate="SEARCH_RESULTS.ALL_RESULTS_SHOWN"
                translate-values="{count: $ctrl.totalItems}"></span>
            </div>
          </div>
        </ng-form>
      </div>

      <div class="messages-container">
        <div class="all-messages">
          <a
            ng-repeat="message in $ctrl.messages track by message.id"
            ui-sref="{{$ctrl.messageDestinationRoute || '^.message'}}({messageId: message.id, returnRoute: $ctrl.currentState})"
            data-cy="message-item-in-list"
            class="single-message row"
            ng-class="{'unread-message': !message.isRead, 'no-pagination-last-message': $ctrl.totalItems < $ctrl.messagesPerPage && $last}">
            <span class="visually-hidden">
              {{message.senderFullName}} {{message.senderName | localizedString}} {{$ctrl.getMessageTypeTranslationKey(message) |
              translate}} {{message.courseUnitRealisation ? (message.courseUnitRealisation.fullName | localizedString) : ''}}
              {{message.title ? message.title : ''}} {{message.localizedTitle ? (message.localizedTitle|localizedString) : ''}}
            </span>
            <div
              ng-class="{'col-8 col-md-9 col-lg-10': $ctrl.confinedContainer, 'col-9 col-sm-10 col-lg-11': !$ctrl.confinedContainer}"
              aria-hidden="true">
              <div class="row">
                <div class="col-12 message-header">
                  <span class="message-sender" ng-if="$ctrl.showSenderFullName(message)">{{message.senderFullName}}</span>
                  <span class="message-sender" ng-if="!$ctrl.showSenderFullName(message)">{{message.senderName | localizedString}}</span>
                  <span class="message-sender-student-number" ng-if="message.senderStudentNumber">({{message.senderStudentNumber}})</span>
                  <span ng-if="message.courseUnitRealisation" class="message-cur-name">
                    | {{message.courseUnitRealisation.fullName | localizedString}}</span
                  >
                  <span class="message-type">
                    | {{$ctrl.getMessageTypeTranslationKey(message) | translate}} {{$ctrl.getMessageTargetName(message)}}</span
                  >
                </div>
                <div class="col-12 message-overview">
                  <span ng-if="message.title" class="message-title">{{message.title}}</span>
                  <span ng-if="message.localizedTitle" class="message-title">{{message.localizedTitle|localizedString}}</span>
                  <span class="message-snipped">
                    <span ng-if="message.title || message.localizedTitle"> | </span>
                    <span ng-if="message.comment">{{$ctrl.getSnippet(message)}}</span>
                    <span ng-if="message.localizedComment">{{$ctrl.getLocalizedSnippet(message)|plainText}}</span>
                  </span>
                </div>
              </div>
            </div>
            <div
              class="message-date-time"
              ng-class="{'col-4 col-md-3 col-lg-2': $ctrl.confinedContainer, 'col-3 col-sm-2 col-lg-1': !$ctrl.confinedContainer}">
              <span class="message-date">{{message.messageTime | localDateFormatUsingDeicticNames}}</span>
              <span class="message-time">{{message.messageTime | localTimeFormat }}</span>
            </div>
          </a>
          <div class="row" ng-if="$ctrl.messages.length === 0 || !$ctrl.messages">
            <div class="col-12">
              <p class="no-messages" translate="MESSAGES.NO_MESSAGES">Ei viestejä</p>
            </div>
          </div>
          <div class="row" ng-if="$ctrl.totalItems > $ctrl.messagesPerPage">
            <div class="col-12">
              <sis-pagination
                [total-items]="$ctrl.totalItems"
                [items-per-page]="$ctrl.messagesPerPage"
                [max-size]="$ctrl.maxSize"
                [(current-page)]="$ctrl.currentPage"
                (current-page-change)="$ctrl.onChange()"
                scroll-into-view-on-page-change="#scroll-target-messages">
              </sis-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default template;
